import { render, staticRenderFns } from "./TablePropsModal.vue?vue&type=template&id=5bcf8ee2&scoped=true"
import script from "./TablePropsModal.vue?vue&type=script&lang=js"
export * from "./TablePropsModal.vue?vue&type=script&lang=js"
import style0 from "./TablePropsModal.vue?vue&type=style&index=0&id=5bcf8ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf8ee2",
  null
  
)

export default component.exports